import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const floatingWrapper = css`
  background-color: ${cssTheme.colors.absolute.white};
`

export const actionButtonWrapper = css`
  padding-block-end: ${spacing(5)};

  border-end-end-radius: 0;
  border-end-start-radius: 0;
`
